import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { MainState } from "./state";

const defaultState: MainState = {
  isLoggedIn: null,
  token: "",
  logInError: false,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: false,
  notifications: [],
  msalConfig: {
    clientId: "",
    authority: "",
  },
  ssoLoggedIn: false,
  mapBoxToken:
    "pk.eyJ1IjoiYWxhaW50ZXJyYTE1IiwiYSI6ImNrMWxpNGRmajAxN2ozbW8zamw1dXJid2EifQ.VsyUeATiiIaAg9yTqxo1yw",
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
